module.exports = __webpack_public_path__ + "img/sight_pin.cc0107e1.png";